import { Delete, Edit, ExpandLess, ExpandMore } from '@mui/icons-material';
import type { IMeasure } from '../../../Interfaces/ILegalTransactionMeasure';
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';

type IProps = {
  measure: IMeasure;
  onDelete: (measureId: number) => void;
  onEdit: (measure: IMeasure) => void;
  onMoveUp: (measure: IMeasure) => void;
  onMoveDown: (measure: IMeasure) => void;
  isFirst: boolean;
  isLast: boolean;
};

export const MeasureCard = ({
  measure,
  onDelete,
  onEdit,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
}: IProps) => {
  return (
    <Card variant='outlined'>
      <CardContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          '&:last-child': {
            // Add this to remove bottom padding
            pb: 2,
          },
        }}
      >
        <Box display='flex' gap={2} alignItems='center'>
          <Typography variant='subtitle1'>{measure.Name}</Typography>
          <Chip
            size='small'
            label={
              measure.attributes.length === 0
                ? 'Keine Attribute'
                : `${measure.attributes.length} Attribute`
            }
          />
          <Chip
            size='small'
            label={
              !measure.automations || measure.automations.length === 0
                ? 'Keine Automatisierungen'
                : `${measure.automations.length} Automatisierungen`
            }
          />
        </Box>
        <Box display='flex' gap={2}>
          <Tooltip title='Nach unten verschieben'>
            <IconButton onClick={() => onMoveDown(measure)} disabled={isLast}>
              <ExpandMore />
            </IconButton>
          </Tooltip>
          <Tooltip title='Nach oben verschieben'>
            <IconButton onClick={() => onMoveUp(measure)} disabled={isFirst}>
              <ExpandLess />
            </IconButton>
          </Tooltip>
          <IconButton onClick={() => onEdit(measure)}>
            <Edit />
          </IconButton>
          <IconButton onClick={() => onDelete(measure.idMeasurement)}>
            <Delete />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};
